export default {
    methods: {
        async searchVatNo(vat) {
            return this.axios.get(route("api.openapi.search-vat"), {
                params: {
                    vat
                }
            }).catch((err) => {
                this.showError(err?.response?.data?.error)
                throw err
            })
        }
    }
};
